import {
  ActionBar,
  ActionBarButtons,
  cardPaymentDetailsShape,
  Column,
  ConfirmationModal,
  EditActionButton,
  invoicePaymentDetailsShape,
  Row,
  useBrowser,
} from "lcm-iot-commons";
import SubscriptionPaymentDetails from "lcm-iot-commons/client/lib/components/Subscriptions/SubscriptionPaymentDetails";
import SubscriptionPaymentEditModal from "lcm-iot-commons/client/lib/components/Subscriptions/SubscriptionPaymentEditModal";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useParams } from "react-router-dom";

type Props = Readonly<{
  disabledEdit: boolean;
  cardPaymentDetails: cardPaymentDetailsShape;
  invoicePaymentDetails: invoicePaymentDetailsShape;
  perInvoice: boolean;
  canChangeToInvoice: boolean;
  onPaymentMethodChange: () => void;
}>;

export default function ConnectSubscriptionPaymentsSection(props: Props) {
  const intl = useIntl();
  const browser = useBrowser();
  const { id: subscriptionId } = useParams<{ id: string }>();

  const {
    disabledEdit,
    cardPaymentDetails,
    invoicePaymentDetails,
    perInvoice,
    canChangeToInvoice,
    onPaymentMethodChange,
  } = props;

  const [showPaymentEditModal, setShowPaymentEditModal] = useState(false);
  const [showUpdatePaymentModal, setShowUpdatePaymentModal] = useState(false);

  const onPaymentUpdateToInvoice = () => {
    setShowPaymentEditModal(false);
    setShowUpdatePaymentModal(true);
  };

  const onPaymentEditDecline = () => {
    setShowPaymentEditModal(false);
  };

  const onPaymentEditAccept = () => {
    setShowPaymentEditModal(false);
    browser.redirectToExtern(`/payment/update/subscription/${subscriptionId}`);
  };

  const onChangeToPaymentPerInvoiceDecline = () => {
    setShowUpdatePaymentModal(false);
  };

  const onChangeToPaymentPerInvoiceAccept = async () => {
    setShowUpdatePaymentModal(false);
    onPaymentMethodChange();
  };

  const paymentEditModal = showPaymentEditModal ? (
    <SubscriptionPaymentEditModal
      onAccept={onPaymentEditAccept}
      onDecline={onPaymentEditDecline}
      isCredit={!perInvoice}
      onChange={onPaymentUpdateToInvoice}
      canChangeToInvoice={canChangeToInvoice}
    />
  ) : null;

  const modalChangeToInvoice = (
    <ConfirmationModal
      id="modal-dialog-invoice"
      show={showUpdatePaymentModal}
      titleText={intl.formatMessage({
        id: "payment_details_edit.change_credit_to_invoice",
      })}
      messageText={intl.formatMessage({
        id: "payment_details_edit.change_to_invoice_description",
      })}
      onConfirm={onChangeToPaymentPerInvoiceAccept}
      onClose={onChangeToPaymentPerInvoiceDecline}
    />
  );

  return (
    <>
      <Row id="subscription-payment-details">
        <Column>
          <ActionBar>
            <h2>
              <FormattedMessage id="subscription_checkout.payment_details_header" />
            </h2>
            <ActionBarButtons>
              <EditActionButton
                id="edit-payment-details-button"
                onClick={() => setShowPaymentEditModal(true)}
                disabled={disabledEdit}
              />
            </ActionBarButtons>
          </ActionBar>
        </Column>
      </Row>
      <SubscriptionPaymentDetails
        cardPaymentDetails={cardPaymentDetails}
        invoicePaymentDetails={invoicePaymentDetails}
        source="subscription"
        onChangeToPaymentPerInvoice={onChangeToPaymentPerInvoiceAccept}
        canChangeToInvoice={canChangeToInvoice}
        // @ts-expect-error TS(2532) FIXME: Property 'intl' does not exist on type...
        intl={intl}
      />
      {paymentEditModal}
      {modalChangeToInvoice}
    </>
  );
}
